import type { Category } from "../categories";

export type Panel = {
  path: number[];
  name: string;
  items: Category[];
};

export function collectPanels(
  items: Category[],
  parentPath: number[] = [],
): Panel[] {
  const panels: Panel[] = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.type === "node") {
      const path = [...parentPath, i];
      panels.push({ path, name: item.name, items: item.children });
      panels.push(...collectPanels(item.children, path));
    }
  }
  return panels;
}

export function collectLeaves(
  items: Category[],
): { name: string; url: string }[] {
  const leaves: { name: string; url: string }[] = [];
  for (const item of items) {
    if (item.type === "leaf") {
      leaves.push({ name: item.name, url: item.url });
    } else {
      leaves.push(...collectLeaves(item.children));
    }
  }
  return leaves;
}

export function pathStartsWith(path: number[], prefix: number[]): boolean {
  return prefix.length <= path.length && prefix.every((v, i) => path[i] === v);
}

export function pathEquals(a: number[], b: number[]): boolean {
  return a.length === b.length && a.every((v, i) => v === b[i]);
}
